<template>
 <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style src="./design/tailwind.css"></style>
